module.exports = {
  myPets: 'I miei animali',
  myProfile: 'Il mio profilo',
  logout: 'Disconnettersi',
};
